import { useState } from 'react';
import type { InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { IconEye, IconEyeOff } from './Icons.js';

/**
 * Passwortfeld mit Augen-Knopf.
 *
 * Auf dem Telefon vertippt man sich leicht, und eine lange Passphrase blind
 * einzugeben, ist der häufigste Grund für „E-Mail oder Passwort stimmt nicht".
 * Der Knopf sagt, was er tut (`aria-pressed` + Name) — ein Auge allein wäre ein
 * Rätsel. Sichtbar bleibt es nur, bis man es wieder verbirgt.
 */
export function PasswordInput(
  props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>,
): React.JSX.Element {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        {...props}
        type={visible ? 'text' : 'password'}
        // Sichtbar getippt ist es trotzdem ein Passwort: keine Korrektur, keine Großschreibung.
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        className={`${props.className ?? 'kw-field'} w-full pr-12`}
      />
      <button
        type="button"
        onClick={() => setVisible((value) => !value)}
        aria-pressed={visible}
        aria-label={visible ? t('password.hide') : t('password.show')}
        className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-ink-muted"
      >
        {visible ? <IconEyeOff /> : <IconEye />}
      </button>
    </div>
  );
}
